import React  from "react";
import MdCard from "../common/MdCard";
import Line from "../../components/charts/Line";
import { useIntl } from "react-intl";

function TrendResults(props) {
  const intl = useIntl();
  const { count = [], date = [] } = props.data;

  const data = {
    datasets: [
      {
        data: count,
      },
    ],
    labels: date,
  };
 
  return (
    <MdCard title={intl.formatMessage({ id: "trend-results" })}>
      <div
        style={{
          height: "90%",
          width: "90%",
          margin: "auto",
        }}
      >
        {count.length && date.length ? <Line data={data} /> : null}
      </div>
    </MdCard>
  );
}

export default TrendResults;
